import { useCallback } from 'react';

import { FormProvider } from 'react-hook-form';

import { Button, FormField, Modal, ModalBody, ModalFooter, ModalHeader } from '@/_components';
import { stopPropagate } from '@/_shared';

import type { PickTicketsItemCreateSchema } from './schema';
import { TableView } from './table-view';
import type { AddInventoryKitItemModalProps } from './use-modal';
import { useAddPickTicketsItems } from './use-modal';

import { InventoryAndKitCombobox } from '../inventory-and-inventory-kit-combobox';

export function AddPickTicketsItems(props: AddInventoryKitItemModalProps) {
  const { form, onSubmit, isPending, onClose } = useAddPickTicketsItems(props);
  const { open } = props;
  const items = form.watch('items');

  const handleDelete = useCallback(
    (id: number) => {
      const newItems = items.filter((item) => item.id !== id);
      form.setValue('items', newItems, {
        shouldDirty: true,
      });
    },
    [form, items]
  );

  const handleDataUpdate = useCallback(
    (data: PickTicketsItemCreateSchema[]) => {
      form.setValue('items', data, {
        shouldDirty: true,
      });
    },
    [form]
  );

  return (
    <Modal
      open={open}
      size="lg"
      onClose={onClose}
      disableBackdropClosing
      disableInternalClosing={isPending}
      className="overflow-visible"
    >
      <ModalHeader>Add Pick Ticket Item</ModalHeader>

      <FormProvider {...form}>
        <form onSubmit={stopPropagate(form.handleSubmit(onSubmit))}>
          <ModalBody>
            <section className="mt-9">
              <FormField control={form.control} name="inventory_and_kit" render={() => <InventoryAndKitCombobox />} />
            </section>

            <section className="mt-3 flex flex-col gap-4">
              <TableView
                tableData={items}
                isEditable
                cacheBuster={items.length}
                handleDelete={handleDelete}
                handleDataUpdate={handleDataUpdate}
              />
            </section>
          </ModalBody>

          <ModalFooter className="mt-6">
            <Button modal type="submit" showLoader={isPending}>
              Done
            </Button>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
}
